<template>
  <div class="noticeDetail">
    <OAModal
      :visible="visible"
      width="900px"
      @on-cancel="$emit('update:visible', false)"
    >
      <div class="title">{{ props.title | isNull }}</div>
      <div class="content">
        <div class="info">
          <div>发送人：{{ userName }}</div>
          <div>发送时间：{{ sendTime }}</div>
        </div>
        <div class="enclosure">
          <div class="enclosureTitle">附件：</div>
          <sky-upload-img :value="props.url" :disabled="true"></sky-upload-img>
        </div>
        <div class="detail">
          <div class="tag">通知详情</div>

          <div class="riceTextContent" v-html="props.content"></div>
        </div>
        <div class="interaction">
          <div>
            <div class="tag">互动详情</div>
            <el-collapse v-model="activeNames">
              <el-collapse-item name="1">
                <template slot="title">
                  <i class="el-icon-success" />已同意{{ readNum }}人
                </template>
                <div class="nameBox" v-if="this.readNum">
                  <div
                    class="nameItem"
                    v-for="(name, index) in readNames"
                    :key="index"
                  >
                    {{ name }}
                  </div>
                </div>
                <div class="nameBox" v-else>暂无数据...</div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <i class="el-icon-question" />未反馈{{ unReadNum }}人
                </template>
                <div class="nameBox" v-if="this.unReadNum">
                  <div
                    class="nameItem"
                    v-for="(name, index) in unReadNames"
                    :key="index"
                  >
                    {{ name }}
                  </div>
                </div>
                <div class="nameBox" v-else>暂无数据...</div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </OAModal>
  </div>
</template>
<script>
import OACard from "@/components/OACard/OACard";
import OAModal from "@/components/OAModal/OAModal";
import notice from "@/services/notice";
import store from "@/store";
export default {
  name: "noticeDetail",
  components: {
    OACard,
    OAModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    props: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeNames: [],
      readNum: this.getReadNum(),
      unReadNum: this.getUnReadNum(),
      readNames: [],
      unReadNames: [],
    };
  },
  filters: {
    isNull(val) {
      return val === undefined || val.trim() === "" ? "-" : val;
    },
  },
  computed: {
    userName() {
      return this.props.sender
    },
    sendTime() {
      return this.props.sendTime ? this.props.sendTime : this.getDate();
    },
  },
  watch: {
    props: {
      handler(val) {
        if (val) {
          this.getReadNames();
          this.getUnReadNames();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getReadNum() {
      //获取已同意人员数
      return this.isEdit ? this.props.readNum : 0;
    },
    getUnReadNum() {
      //获取未反馈人员数
      return this.isEdit
        ? this.props.unReadNum
        : this.props.receiverInfo.length;
    },
    getReadNames() {
      //获取已同意人员名单
      this.readNames = this.isEdit ? this.props.readNames : [];
    },
    async getUnReadNames() {
      //预览情况下获取未反馈人员的名单
      this.unReadNames = this.isEdit
        ? this.props.unReadNames
        : await this.getNameList(this.props.receiverInfo);
    },
    async getNameList(receiverInfo) {
      //获取人员名称数组
      let organization = await this.getOrganization();
      return this.handleNameList(receiverInfo, organization);
    },
    handleNameList(receiverInfo, organization) {
      //接收两个参数，包含部门id、员工id信息的数组和组织架构信息，返回人员名称数组
      return receiverInfo.map((item) => {
        return item.reduce((prev, curr) => {
          let temp = prev.filter((i) => {
            return i.id == curr;
          });
          return temp[0].isPerson ? temp[0].name : temp[0].children;
        }, organization);
      });
    },
    async getOrganization() {
      //获取组织架构数据
      let data = [];
      let res = await notice.getOrganization();
      data[0] = res.data;
      return data;
    },
    getDate() {
      //获取当前时间
      let d = new Date();
      return `${d.getFullYear()}-${
        d.getMonth() + 1
      }-${d.getDate()}  ${d.getHours()}:${d.getMinutes()}`;
    },
  },
};
</script>
<style lang="scss">
.noticeDetail {
  .OAModal {
    .el-dialog {
      padding-bottom: 15px;
      .el-dialog__body {
        height: 600px;
        overflow: auto;
      }
      .tag {
        font-size: 17px;
        line-height: 17px;
        color: #20a0ff;
        border-left: 2px solid #20a0ff;
        padding-left: 10px;
      }
      .title {
        font-size: 17px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }
      .content {
        .info {
          font-size: 14px;
          line-height: 20px;
          color: #616266;
        }
        .detail {
          padding: 10px;
          .riceTextContent {
            width: 800px;
            min-height: 100px;
            margin: 20px 10px;
            overflow: auto;
          }
        }
        .enclosure {
          display: flex;
          margin: 20px 0;
          .enclosureTitle {
            font-size: 15px;
            font-weight: bold;
            color: #333;
            margin-right: 10px;
          }
        }
        .interaction {
          padding: 5px;
          .el-collapse {
            margin: 20px 10px 10px;
            border: none;
            .el-collapse-item {
              .el-collapse-item__header,
              .el-collapse-item__wrap {
                border: none;
              }
              .el-collapse-item__header {
                width: 200px;
              }
              .el-collapse-item__content {
                max-height: 300px;
                overflow: auto;
                padding-bottom: 10px;
              }
              .el-icon-success {
                font-size: 18px;
                color: #67C23A;
                padding-right: 10px;
              }
              .el-icon-question {
                font-size: 18px;
                color: #ccc;
                padding-right: 10px;
              }
              .nameBox {
                width: 100%;
                padding-left: 20px;
                display: flex;
                flex-wrap: wrap;
                .nameItem {
                  padding: 5px 15px;
                  // width: 80px;
                  // height: 24px;
                  // overflow: hidden;
                  // text-overflow: ellipsis;
                  // white-space: nowrap;
                  // margin-right: 7px;
                  // flex: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/notice/noticeDetail.vue